import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SubScheduleItem } from '../../../../../api/model';
import Modal from '../../../../modules/Modal';

interface Props {
  data: SubScheduleItem | null;
  onClose: () => void;
  save: (params: SubScheduleItem) => void | undefined;
}

function SubScheduleFormModal({ onClose, data, save }: Props) {
  const { t } = useTranslation();

  const { register, handleSubmit } = useForm<SubScheduleItem>({
    defaultValues: data || {
      sub_schedule_item_id: undefined,
      milestone: undefined,
      notification_timing: undefined,
      destination: undefined,
      message: undefined,
      plan_from_on: undefined,
      plan_end_on: undefined,
      actual_from_on: undefined,
      actual_end_on: undefined,
      editable: true,
    },
  });

  const onClickSubmit = useCallback(async () => {
    await handleSubmit(save)();
    onClose();
  }, [handleSubmit, save, onClose]);

  return (
    <Modal active additionalClassName="popupfr800" displayCloseButton onClose={onClose}>
      <div className="popupfr popupfr1030">
        <div className="pop-tablefr1">
          <div>
            <table>
              <tbody>
                <tr>
                  <th>
                    <label htmlFor="ip85-1">{t('分類')}</label>
                  </th>
                  <td>{t('サブ')}</td>
                </tr>
                <tr>
                  <th>
                    <label htmlFor="ip85-2">{t('マイルストーン')}</label>
                  </th>
                  <td>
                    <input type="text" {...register('milestone')} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <h3 className="notif">{t('通知')}</h3>

        <div className="pop-tablefr1">
          <div>
            <table>
              <tbody>
                <tr>
                  <th>
                    <label htmlFor="ip85-4">{t('タイミング')}</label>
                  </th>
                  <td className="ktmg">
                    <span>{t('既定のタイミング')}</span>
                    <input type="number" {...register('notification_timing')} defaultValue={1} />
                  </td>
                </tr>
                <tr>
                  <th>
                    <label htmlFor="dp85-9">{t('送付先')}</label>
                  </th>
                  <td>
                    <span className="dropdown kisyutantou">
                      <select {...register('destination')}>
                        <option value="1">{t('機種担当')}</option>
                        <option value="2">{t('原作推進担当')}</option>
                        <option value="3">{t('情報収集担当')}</option>
                        <option value="4">{t('技術情報担当')}</option>
                        <option value="5">{t('確認依頼者')}</option>
                        <option value="6">{t('承認依頼者')}</option>
                      </select>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="threadfr2 mb20">
          <label htmlFor="message">{t('メッセージ')}</label>
          <div>
            <textarea id="message" rows={10} cols={33} {...register('message')} />
          </div>
        </div>
        <div className="messagead">
          <p>{t('***にすると、***の部分はマイルストーン名に置換されます。')}</p>
        </div>
        <div className="btnfr btnfr2 mb0 mt0">
          <div>
            <span className="btn2 btnbg-g mr10" onClick={onClose}>
              <span className="modal-close2">{t('キャンセル')}</span>
            </span>
            <span>
              <input type="submit" value="OK" className="btn1 lsp1" onClick={onClickSubmit} />
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default SubScheduleFormModal;
